import { Stack } from "@mui/material";
import { SettingsProfilesList } from "./SettingsProfilesList";

export const ReservationSettingsTab = () => (
  <Stack spacing={1} sx={{ flex: 1, pt: 2 }}>
    <SettingsProfilesList />
  </Stack>
);
